import Q2_2_1 from './Q2_2_1';

export default Q2_2_1;
